/* unplugin-vue-components disabled */import script from "./File.vue?vue&type=script&setup=true&lang=js"
export * from "./File.vue?vue&type=script&setup=true&lang=js"

import "./File.vue?vue&type=style&index=0&id=21e5ea2a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21e5ea2a"]])

export default __exports__